import './GeneralSettings.scss';
import { GeneralSettingsFeatures } from './GeneralSettingsFeatures';
import { DeskControllerBase } from '../DeskControllerBase';
import { AttendanceConstants } from '../AttendanceConstants';
import { AttendanceFeatures } from '../AttendanceFeatures';
import { ActiveMessageSegmentEventsConstants } from '../AttendanceSegmentEvents';
import { arraysEqual } from 'data/array';
import { GeneralSettingsConstants, GeneralSettingsTracks } from './GeneralSettingsConstants';
import { ToastType } from 'modules/application/misc/ToastService';
import { BuilderFeatures } from '../../portal-submodule-builder/templates/builder/BuilderFeatures';
import { ActiveMessageSettingsConstants } from 'modules/shared/ActiveMessageDesk/ActiveMessageSettingsConstants';
import { ActiveMessageFeatures } from 'modules/shared/featureToggle/ActiveMessageFeatures';
export const TAG_KEY = 'blip:desk:tags';
export class GeneralSettingsController extends DeskControllerBase {
    static $inject = ['application', 'DeskConfigurationService', 'LoadingService', 'BucketService', '$scope', '$translate', '$window', 'ConfigurationsService', 'PermissionsService', 'SegmentService', 'BlipToastService', 'ActiveMessageDeskSharedService', '$state'];
    constructor(application, DeskConfigurationService, LoadingService, BucketService, $scope, $translate, $window, ConfigurationsService, PermissionsService, SegmentService, BlipToastService, ActiveMessageDeskSharedService, $state) {
        'ngInject';
        super(application, LoadingService, DeskConfigurationService, $scope);
        this.application = application;
        this.DeskConfigurationService = DeskConfigurationService;
        this.LoadingService = LoadingService;
        this.BucketService = BucketService;
        this.$scope = $scope;
        this.$translate = $translate;
        this.$window = $window;
        this.ConfigurationsService = ConfigurationsService;
        this.PermissionsService = PermissionsService;
        this.SegmentService = SegmentService;
        this.BlipToastService = BlipToastService;
        this.ActiveMessageDeskSharedService = ActiveMessageDeskSharedService;
        this.$state = $state;
        this.canSaveTags = false;
        this.tags = [];
        this.showTags = false;
        this.canSaveAutoDistribution = false;
        this.canSaveAgentResponseTimeAlert = false;
        this.canSaveCustomerResponseTimeAlert = false;
        this.canSaveAutoClosingOfTicketsByCustomerInactivity = false;
        this.showAutoClosingOfTicketsByCustomerInactivity = false;
        this.isAutoClosingOfTicketsByCustomerInactivityAllowed = false;
        this.isAutoClosingOfTicketsByCustomerInactivityEnabled = true;
        this.autoClosingOfTicketsByCustomerInactivityAddTagsWhenClosingTheTicket = true;
        this.validMessageBeforeAutoClosingTimeValue = true;
        this.canSendEmojis = true;
        this.canSendAttachment = true;
        this.blockExternalAttachment = true;
        this.showOptionToBlockExternalFile = true;
        this.isWhatsAppChannelConnected = false;
        this.isContactFieldsValid = true;
        this.isSearchSourceValid = true;
        this.isRouterIdentityValid = true;
        this.canSaveActiveMessageConfiguration = false;
        this.showActiveMessageContactSearchWarning = true;
        this.activeMessageRouterErrorMessage = '';
        this.openPendingSettingsModal = false;
        this.routerIdDomain = ActiveMessageSettingsConstants.DOMAIN_MSG;
        this.isActiveMessageConfigInService = false;
        this.waitingTicketsCountHiddenness = false;
        this.redirectWhenNoAgentsQueue = false;
        this.onTagsChange = async (event) => {
            if (event && !arraysEqual(this.tags, event.detail?.data)) {
                this.tags = await event.detail?.data;
                this.canSaveTags = true;
            }
        };
        this.toggleTagsRequired = async (event) => {
            if (this.isTagsRequired === event.detail.checked) {
                return;
            }
            this.isTagsRequired = await event.detail.checked;
            if (this.isTagsRequired) {
                if (this.tags && this.tags.length > 0) {
                    this.canSaveTags = true;
                }
            }
            else {
                this.canSaveTags = true;
            }
        };
        this.saveTicketTransferOption = async (event) => {
            const transferWithoutAgentsConfig = await this.getDeskConfiguration(AttendanceConstants.TRANSFER_WITHOUT_AGENTS_CONFIG, false);
            this.canTransferWithoutAgents = await event.detail.checked;
            if (transferWithoutAgentsConfig !== this.canTransferWithoutAgents) {
                this.SegmentService.createBotTrack(this.canTransferWithoutAgents ? AttendanceConstants.TEAM_TRANSFER_ENABLED : AttendanceConstants.TEAM_TRANSFER_DISABLED, this.application);
                await this.saveDeskConfiguration(AttendanceConstants.TRANSFER_WITHOUT_AGENTS_CONFIG, this.canTransferWithoutAgents);
            }
        };
        this.saveActiveMessagesOption = async (event) => {
            const isActiveMessagesEnabledPreviewValue = await this.getDeskConfiguration(GeneralSettingsConstants.ACTIVE_MESSAGE_ENABLED, false, true);
            const isActiveMessageSettingsInProgressPreviewValue = await this.getDeskConfiguration(GeneralSettingsConstants.ACTIVE_MESSAGE_SETTINGS_PROGRESS, false);
            const hasPreviewChanged = isActiveMessagesEnabledPreviewValue !== isActiveMessageSettingsInProgressPreviewValue;
            const isSettingsInProgress = this.isActiveMessageSettingsInProgress && this.isActiveMessagesEnabled;
            if ((hasPreviewChanged || isSettingsInProgress) && event.detail.checked) {
                return;
            }
            this.LoadingService.startLoading();
            this.isActiveMessageConfigInService = true;
            this.isActiveMessagesEnabled = event.detail.checked;
            this.SegmentService.createApplicationTrack({
                trackEvent: this.isActiveMessagesEnabled ? ActiveMessageSegmentEventsConstants.ACTIVE_MESSAGE_ENABLED : ActiveMessageSegmentEventsConstants.ACTIVE_MESSAGE_DISABLED,
                application: this.application,
            });
            if (this.isActiveMessageSettingsValidationEnabled) {
                await this.ConfigurationsService.set(GeneralSettingsConstants.POSTMASTER, { [GeneralSettingsConstants.ACTIVE_MESSAGE_SETTINGS_PROGRESS]: this.isActiveMessagesEnabled }, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled);
                this.isActiveMessageSettingsInProgress = this.isActiveMessagesEnabled;
            }
            if (!this.isActiveMessagesEnabled) {
                await this.saveDeskConfiguration(GeneralSettingsConstants.ACTIVE_MESSAGE_CONFIGURATION_ROUTER_IDENTITY, '', false);
                this.pendingActiveMessageSettings = undefined;
            }
            if (this.isActiveMessagesEnabled || this.isActiveMessageSettingsInProgress) {
                await this.loadActiveMessageConfiguration();
            }
            await this.saveDeskConfiguration(GeneralSettingsConstants.ACTIVE_MESSAGE_ENABLED, this.isActiveMessagesEnabled, !this.isActiveMessageSettingsInProgress);
            this.LoadingService.stopLoading();
            this.isActiveMessageConfigInService = false;
            if (this.isActiveMessageSettingsInProgress) {
                this.toggleModal();
            }
        };
        this.saveDirectTicketTransferOption = async (event) => {
            const transferDirectlyConfig = await this.getDeskConfiguration(AttendanceConstants.TRANSFER_DIRECTLY_CONFIG, false);
            this.canTransferDirectly = event.detail.checked;
            if (transferDirectlyConfig !== this.canTransferDirectly) {
                this.SegmentService.createBotTrack(AttendanceConstants.DIRECT_TRANSFER_ENABLED, this.application, { enebled: this.canTransferDirectly });
                await this.saveDeskConfiguration(AttendanceConstants.TRANSFER_DIRECTLY_CONFIG, this.canTransferDirectly);
            }
        };
        this.saveEmojis = async (event) => {
            const switchSendEmojis = event.detail.checked;
            if (switchSendEmojis) {
                this.SegmentService.createBotTrack('helpdesk-general-settings-emojis-enabled', this.application);
            }
            else {
                this.SegmentService.createBotTrack('helpdesk-general-settings-emojis-disabled', this.application);
            }
            if (this.canSendEmojis !== switchSendEmojis) {
                await this.saveDeskConfiguration(GeneralSettingsConstants.CAN_SEND_EMOJI, switchSendEmojis);
            }
        };
        this.saveAttachment = async (event) => {
            const switchSendAttachment = event.detail.checked;
            if (switchSendAttachment) {
                this.SegmentService.createBotTrack('helpdesk-general-settings-attachment-enabled', this.application);
            }
            else {
                this.SegmentService.createBotTrack('helpdesk-general-settings-attachment-disabled', this.application);
                await this.saveDeskConfiguration(GeneralSettingsConstants.BLOCK_EXTERNAL_ATTACHMENT, false, false);
            }
            this.showOptionToBlockExternalFile = switchSendAttachment;
            await this.saveDeskConfiguration(GeneralSettingsConstants.CAN_SEND_ATTACHMENT, switchSendAttachment);
        };
        this.saveOptionAttachment = async (event) => {
            const switchSendExternalAttachment = event.detail.checked;
            const trackEvent = switchSendExternalAttachment
                ? AttendanceConstants.SETTING_TO_SEND_EXTERNAL_FILE_ENABLED
                : AttendanceConstants.SETTING_TO_SEND_EXTERNAL_FILE_DISABLED;
            this.SegmentService.createApplicationTrack({ trackEvent, application: this.application, payload: {} });
            await this.saveDeskConfiguration(GeneralSettingsConstants.BLOCK_EXTERNAL_ATTACHMENT, switchSendExternalAttachment);
        };
        this.toggleAttendantsAvailablePerQueue = async (event) => {
            if (this.redirectWhenNoAgentsQueue === event.detail.checked) {
                return;
            }
            this.redirectWhenNoAgentsQueue = event.detail.checked;
            const trackEvent = (this.redirectWhenNoAgentsQueue
                ? GeneralSettingsTracks.GENERAL_SETTING_ATTENDANTS_AVAILABLE_QUEUE_ENABLED
                : GeneralSettingsTracks.GENERAL_SETTING_ATTENDANTS_AVAILABLE_QUEUE_DISABLED);
            this.SegmentService.createApplicationTrack({ trackEvent, application: this.application });
            await this.saveDeskConfiguration(GeneralSettingsConstants.REDIRECT_WHEN_NO_AGENTS_ON_QUEUE, this.redirectWhenNoAgentsQueue);
        };
        this.toggleAutoClosingOfTicketsByCustomerInactivity = async (event) => {
            if (this.showAutoClosingOfTicketsByCustomerInactivity === event.detail.checked) {
                return;
            }
            this.showAutoClosingOfTicketsByCustomerInactivity = event.detail.checked;
            this.isAutoClosingOfTicketsByCustomerInactivityEnabled = this.showAutoClosingOfTicketsByCustomerInactivity;
            if (this.isInvaliddAutoClosingOfTicketsByCustomerInactivityTimeValue() && this.isAutoClosingOfTicketsByCustomerInactivityEnabled) {
                await this.setDangerAttribute('auto-closing-of-tickets-customer-inactivity-time-input', false);
                return;
            }
            try {
                this.LoadingService.startLoading();
                if (!GeneralSettingsConstants.hasOwnProperty('AUTOMATIC_CLOSED_TICKET_ENABLED')) {
                    return;
                }
                await this.ConfigurationsService.set(GeneralSettingsConstants.POSTMASTER, {
                    [GeneralSettingsConstants.AUTOMATIC_CLOSED_TICKET_ENABLED]: this.isAutoClosingOfTicketsByCustomerInactivityAllowed && this.isAutoClosingOfTicketsByCustomerInactivityEnabled,
                }, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled);
                if (this.isAutoClosingOfTicketsByCustomerInactivityEnabled != this.isAutoClosingOfTicketsByCustomerInactivityEnabledInitial) {
                    this.isAutoClosingOfTicketsByCustomerInactivityEnabledInitial = this.isAutoClosingOfTicketsByCustomerInactivityEnabled;
                    const trackEvent = (this.isAutoClosingOfTicketsByCustomerInactivityEnabled ?
                        'helpdesk-general-settings-ticket-closure-enabled' :
                        'helpdesk-general-settings-ticket-closure-disabled');
                    this.SegmentService.createApplicationTrack({ trackEvent,
                        application: this.application,
                        payload: {
                            autoRemoveIsEnabled: this.removeTicketClosedAttendance,
                            messageIsEnabled: this.messageBeforeAutoClosing,
                            tagsIsEnabled: this.autoClosingOfTicketsByCustomerInactivityAddTagsWhenClosingTheTicket,
                            FirstMessageIsEnabled: this.autoClosingOfTicketsByCustomerInactivityOnlyWhenHasAttendantInteraction,
                        },
                    });
                }
                const successMsg = await this.$translate('utils.successMsg.1');
                this.showToast(successMsg, ToastType.Success);
            }
            catch (error) {
                const errorMsg4 = await this.$translate('utils.errorMsg.4');
                this.showToast(errorMsg4, ToastType.Danger);
            }
            finally {
                this.LoadingService.stopLoading();
            }
        };
        this.toggleAgentResponseTimeAlert = async (event) => {
            if (this.showAgentResponseTimeAlert === event.detail.checked) {
                return;
            }
            this.showAgentResponseTimeAlert = event.detail.checked;
            this.agentResponseTimeAlertEnabled = this.showAgentResponseTimeAlert;
            if (this.showAgentResponseTimeAlert) {
                if (!this.isNullOrUndefinedOrNaN(this.agentResponseTimeAlert)) {
                    this.startAgentResponseTimeAlert = false;
                    this.saveDeskConfiguration(GeneralSettingsConstants.AGENT_RESPONSE_DELAY_ENABLED, this.agentResponseTimeAlertEnabled);
                    this.SegmentService.createBotTrack('helpdesk-general-settings-agent-response-delay-enabled', this.application);
                }
                else {
                    this.startAgentResponseTimeAlert = true;
                }
            }
            else {
                this.SegmentService.createBotTrack('helpdesk-general-settings-agent-response-delay-disabled', this.application);
                this.saveDeskConfiguration(GeneralSettingsConstants.AGENT_RESPONSE_DELAY_ENABLED, this.agentResponseTimeAlertEnabled);
            }
        };
        this.toggleCustomerResponseTimeAlert = async (event) => {
            if (this.customerResponseTimesAlertEnabled === event.detail.checked) {
                return;
            }
            this.showCustomerResponseTimesAlert = event.detail.checked;
            this.customerResponseTimesAlertEnabled = this.showCustomerResponseTimesAlert;
            if (this.showCustomerResponseTimesAlert) {
                if (!this.isNullOrUndefinedOrNaN(this.customerWarningResponseTimeAlert) || !this.isNullOrUndefinedOrNaN(this.customerMaxResponseTimeAlert)) {
                    this.startCustomerResponseTimeAlert = false;
                    this.saveDeskConfiguration(GeneralSettingsConstants.CUSTOMER_RESPONSE_DELAY_ENABLED, this.customerResponseTimesAlertEnabled);
                    this.SegmentService.createBotTrack('helpdesk-general-settings-customer-response-delay-enabled', this.application);
                }
                else {
                    this.startCustomerResponseTimeAlert = true;
                }
            }
            else {
                this.saveDeskConfiguration(GeneralSettingsConstants.CUSTOMER_RESPONSE_DELAY_ENABLED, this.customerResponseTimesAlertEnabled);
                this.SegmentService.createBotTrack('helpdesk-general-settings-customer-response-delay-disabled', this.application);
            }
        };
        this.onChangeAgentResponseTimeAlertValue = async (event) => {
            if (this.isValidUnity(parseFloat(event.detail.value))) {
                event.srcElement.danger = false;
                this.agentResponseTimeAlert = parseFloat(event.detail.value);
                this.canSaveAgentResponseTimeAlert = true;
            }
            else {
                event.srcElement.danger = true;
                event.srcElement.errorMessage = await this.$translate('attendance-settings.autoDistribution.tip');
                this.canSaveAgentResponseTimeAlert = false;
            }
        };
        this.onChangeAgentResponseTimeAlertUnity = async (event) => {
            this.agentResponseTimeUnity = event.detail.value;
            if (!this.isInvalidAgentResponseTimeAlerts()) {
                this.canSaveAgentResponseTimeAlert = true;
            }
        };
        this.onChangeCustomerResponseTimeAlerts = async () => {
            if (await this.isNotEmptyCustomerAlertInputs()) {
                await this.validateCustomerResponseTimes();
            }
        };
        this.validFormAutoClosingOfTicketsByCustomerInactivity = async () => {
            const autoClosingOfTicketsCustomerInactivityValueInput = document.getElementById('auto-closing-of-tickets-customer-inactivity-time-input');
            const autoClosingOfTicketsCustomerInactivityUnityInput = document.getElementById('auto-closing-of-tickets-customer-inactivity-time-unity');
            let allValid = true;
            if (this.isNullOrUndefinedOrNaN(autoClosingOfTicketsCustomerInactivityUnityInput.value)) {
                allValid = false;
                autoClosingOfTicketsCustomerInactivityUnityInput.danger = true;
            }
            else {
                autoClosingOfTicketsCustomerInactivityUnityInput.danger = false;
                if (autoClosingOfTicketsCustomerInactivityUnityInput.value) {
                    this.autoClosingOfTicketsByCustomerInactivityTimeUnity = autoClosingOfTicketsCustomerInactivityUnityInput.value;
                }
            }
            if (!this.isValidUnity(parseFloat(autoClosingOfTicketsCustomerInactivityValueInput.value))) {
                autoClosingOfTicketsCustomerInactivityValueInput.danger = true;
                autoClosingOfTicketsCustomerInactivityValueInput.errorMessage = this.$translate.instant('attendance-settings.autoClosingOfTicketsByInactivity.byCustomer.inputTimeTip');
                allValid = false;
            }
            else {
                if (this.validMaxInputTime(parseFloat(autoClosingOfTicketsCustomerInactivityValueInput.value), parseFloat(autoClosingOfTicketsCustomerInactivityUnityInput.value))) {
                    allValid = false;
                    autoClosingOfTicketsCustomerInactivityValueInput.danger = true;
                    const unit = this.autoClosingOfTicketsByCustomerInactivityTimeUnity === 60 ? this.$translate.instant('attendance-settings.timeUnities.mins') : this.$translate.instant('attendance-settings.timeUnities.hours');
                    const total = this.autoClosingOfTicketsByCustomerInactivityTimeUnity === 60 ? this.limitMinutes : this.limitHour;
                    autoClosingOfTicketsCustomerInactivityValueInput.errorMessage = this.$translate.instant('attendance-settings.errors.valueMaxInvalid', { unit: unit, total: total });
                }
                else {
                    autoClosingOfTicketsCustomerInactivityValueInput.danger = false;
                    this.autoClosingOfTicketsByCustomerInactivityTimeValue = parseFloat(autoClosingOfTicketsCustomerInactivityValueInput.value.replace('.', ''));
                }
            }
            if (this.useMessageBeforeAutoClosing) {
                allValid = await this.validMessageBeforeAutoClosingDownTimeValue() && await this.validMessageBeforeAutoClosing() && allValid;
            }
            if (allValid && !this.isInvaliddAutoClosingOfTickets()) {
                this.canSaveAutoClosingOfTicketsByCustomerInactivity = true;
            }
            else {
                this.canSaveAutoClosingOfTicketsByCustomerInactivity = false;
            }
        };
        this.onChangeAutoClosingOfTicketsByCustomerInactivityValueOrUnity = async () => {
            await this.validFormAutoClosingOfTicketsByCustomerInactivity();
        };
        this.toggleAutoDistribution = async (event) => {
            this.showAutoDistribution = event.detail.checked;
            if (this.showAutoDistribution === this.autoDistributionEnabled) {
                return;
            }
            this.autoDistributionEnabled = this.showAutoDistribution;
            if (this.autoDistributionEnabled) {
                if (!this.isNullOrUndefinedOrNaN(this.agentSlots)) {
                    this.saveDeskConfiguration(GeneralSettingsConstants.AGENT_SLOTS_ENABLED, this.autoDistributionEnabled);
                    this.SegmentService.createBotTrack('helpdesk-general-settings-auto-distribution-enabled', this.application);
                }
            }
            else {
                this.saveDeskConfiguration(GeneralSettingsConstants.AGENT_SLOTS_ENABLED, this.autoDistributionEnabled);
                this.SegmentService.createBotTrack('helpdesk-general-settings-auto-distribution-disabled', this.application);
            }
        };
        this.onChangeAutoDistributionValue = async (event) => {
            const slots = parseFloat(event.detail.value);
            if (event.detail.value && this.isValidUnity(slots)) {
                this.agentSlots = slots;
                event.srcElement.danger = false;
                this.canSaveAutoDistribution = true;
            }
            else {
                event.srcElement.danger = true;
                event.srcElement.errorMessage = await this.$translate('attendance-settings.autoDistribution.tip');
                this.canSaveAutoDistribution = false;
            }
        };
        this.toggleTags = async (event) => {
            const switchTags = event.detail.checked;
            if (this.showTags === switchTags) {
                return;
            }
            this.showTags = switchTags;
            if (this.showTags) {
                this.SegmentService.createBotTrack('helpdesk-general-settings-tags-enabled', this.application);
            }
            else {
                this.SegmentService.createBotTrack('helpdesk-general-settings-tags-disabled', this.application);
            }
            await this.saveTags();
        };
        this.saveAudio = async (event) => {
            this.canSendAudioRecording = event.detail.checked;
            if (this.canSendAudioRecording) {
                this.SegmentService.createBotTrack('helpdesk-general-settings-audio-recording-enabled', this.application);
            }
            else {
                this.SegmentService.createBotTrack('helpdesk-general-settings-audio-recording-disabled', this.application);
            }
            await this.saveDeskConfiguration(GeneralSettingsConstants.CAN_SEND_AUDIO_RECORDING, this.canSendAudioRecording);
        };
        this.toggleAutoClosingOnlyWhenHasAttendantInteraction = async (event) => {
            this.autoClosingOfTicketsByCustomerInactivityOnlyWhenHasAttendantInteraction = event.detail.checked;
            await this.validFormAutoClosingOfTicketsByCustomerInactivity();
        };
        this.toggleAddTagsWhenClosingTheTicket = async (event) => {
            if (this.autoClosingOfTicketsByCustomerInactivityAddTagsWhenClosingTheTicket === event.detail.checked) {
                return;
            }
            this.autoClosingOfTicketsByCustomerInactivityAddTagsWhenClosingTheTicket = event.detail.checked;
            await this.validFormAutoClosingOfTicketsByCustomerInactivity();
            if (this.autoClosingOfTicketsByCustomerInactivityAddTagsWhenClosingTheTicket && this.autoClosingOfTicketsByCustomerInactivityTags.length === 0) {
                this.canSaveAutoClosingOfTicketsByCustomerInactivity = false;
            }
            this.setDangerAttribute('auto-closing-of-tickets-customer-inactivity-add-tags-when-closing-the-ticket-values-tags', false);
        };
        this.toggleRemoveTicketClosedAttendance = async (event) => {
            this.removeTicketClosedAttendance = event.detail.checked;
            this.onChangeAutoClosingOfTicketsByCustomerInactivityValueOrUnity();
        };
        this.toggleUseMessageBeforeAutoClosing = async (event) => {
            this.useMessageBeforeAutoClosing = event.detail.checked;
            if (!this.useMessageBeforeAutoClosing) {
                this.messageBeforeAutoClosing = '';
                this.messageBeforeAutoClosingTimeValue = undefined;
            }
            await this.validFormAutoClosingOfTicketsByCustomerInactivity();
            this.validMessageBeforeAutoClosingTimeValue = true;
        };
        this.validMessageBeforeAutoClosingDownTimeValue = async () => {
            const customerAutoClossingInactivityTime = this.autoClosingOfTicketsByCustomerInactivityTimeValue * this.autoClosingOfTicketsByCustomerInactivityTimeUnity;
            const customerMessageBeforeAutoClosedValue = this.messageBeforeAutoClosingTimeValue * this.messageBeforeAutoClosingTimeUnity;
            const customerMessageBeforeAutoClosedTime = customerAutoClossingInactivityTime - customerMessageBeforeAutoClosedValue;
            this.validMessageBeforeAutoClosingTimeValue = true;
            if (customerAutoClossingInactivityTime < customerMessageBeforeAutoClosedTime || customerMessageBeforeAutoClosedTime <= 0) {
                this.validMessageBeforeAutoClosingTimeValue = false;
                return false;
            }
            if (this.messageBeforeAutoClosingTimeValue == 0 || this.isNullOrUndefinedOrNaN(this.messageBeforeAutoClosingTimeValue)) {
                this.validMessageBeforeAutoClosingTimeValue = false;
                return false;
            }
            return true;
        };
        this.validMessageBeforeAutoClosing = async () => {
            if (this.messageBeforeAutoClosing.trim().length == 0) {
                return false;
            }
            return true;
        };
        this.onChangeMessageBeforeAutoClosing = async (event) => {
            this.messageBeforeAutoClosing = event.detail.value.trim();
            const isValidMessage = await this.validMessageBeforeAutoClosing();
            event.srcElement.danger = !isValidMessage;
            this.validFormAutoClosingOfTicketsByCustomerInactivity();
        };
        this.onChangeMessageBeforeAutoClosingDownTimeValue = async (event) => {
            this.messageBeforeAutoClosingTimeValue = event.detail.value.replace('.', '');
            this.validFormAutoClosingOfTicketsByCustomerInactivity();
        };
        this.onChangeMessageBeforeAutoClosingDownTimeUnity = async (event) => {
            this.messageBeforeAutoClosingTimeUnity = event.detail.value;
            this.validFormAutoClosingOfTicketsByCustomerInactivity();
        };
        this.saveEnabledNumberCustomerWaiting = async (event) => {
            if (this.waitingTicketsCountHiddenness === event.detail.checked) {
                return;
            }
            this.waitingTicketsCountHiddenness = event.detail.checked;
            try {
                await this.saveDeskConfiguration(GeneralSettingsConstants.WAITING_TICKETS_COUNT_HIDDENNESS, this.waitingTicketsCountHiddenness);
            }
            catch (error) {
                this.waitingTicketsCountHiddenness = !this.waitingTicketsCountHiddenness;
            }
            finally {
                this.SegmentService
                    .createApplicationTrack({
                    trackEvent: GeneralSettingsTracks.GENERAL_SETTING_TICKET_NUMBER,
                    application: this.application,
                    payload: {
                        isEnabled: this.waitingTicketsCountHiddenness,
                    },
                });
            }
        };
        this.onAutoClosingOfTicketsByCustomerInactivityTagsChangeValues = async (event) => {
            if (!this.isAutoClosingOfTicketsByCustomerInactivityEnabled && !this.autoClosingOfTicketsByCustomerInactivityAddTagsWhenClosingTheTicket) {
                return;
            }
            if (event && !arraysEqual(this.autoClosingOfTicketsByCustomerInactivityTags, event.detail?.data)) {
                this.autoClosingOfTicketsByCustomerInactivityTags = event.detail?.data || [];
                if (this.autoClosingOfTicketsByCustomerInactivityTags && (!this.autoClosingOfTicketsByCustomerInactivityTags
                    || this.autoClosingOfTicketsByCustomerInactivityTags?.length === 0)) {
                    this.canSaveAutoClosingOfTicketsByCustomerInactivity = false;
                }
                else {
                    this.canSaveAutoClosingOfTicketsByCustomerInactivity = true;
                }
            }
            this.setDangerAttribute('auto-closing-of-tickets-customer-inactivity-add-tags-when-closing-the-ticket-values-tags', (this.autoClosingOfTicketsByCustomerInactivityTags
                && (!this.autoClosingOfTicketsByCustomerInactivityTags || this.autoClosingOfTicketsByCustomerInactivityTags?.length === 0)));
            await this.validFormAutoClosingOfTicketsByCustomerInactivity();
        };
        this.isContactFieldSelected = (contactFieldName) => {
            return this.activeMessageConfiguration.contactFieldsSearch.includes(contactFieldName);
        };
        this.isSearchSourceSelected = (sourceName) => {
            return this.activeMessageConfiguration.searchSource.includes(sourceName);
        };
        this.toggleContactFieldSearch = async (event) => {
            const contactFieldName = event.detail.name;
            const contactFieldChecked = event.detail.checked;
            if (contactFieldChecked) {
                this.addContactFieldToSearch(contactFieldName);
            }
            else {
                this.removeContactFieldFromSearch(contactFieldName);
            }
            this.canSaveActiveMessageConfiguration = await this.checkIfActiveMessageConfigurationCanBeSaved();
        };
        this.toggleSearchSource = async (event) => {
            const sourceName = event.detail.name;
            const sourceChecked = event.detail.checked;
            if (sourceChecked) {
                this.addSearchToSearch(sourceName);
            }
            else {
                this.removeSourceFromSearch(sourceName);
            }
            this.canSaveActiveMessageConfiguration = await this.checkIfActiveMessageConfigurationCanBeSaved();
        };
        this.saveActiveMessageConfiguration = async () => {
            if (!this.canSaveActiveMessageConfiguration) {
                return;
            }
            try {
                this.LoadingService.startLoading();
                this.isActiveMessageConfigInService = true;
                const activeMessageContactFieldsSearch = this.activeMessageConfiguration.contactFieldsSearch.join(',');
                const activeMessageSearchSource = this.activeMessageConfiguration.searchSource.join(',');
                const saveConfigurations = [
                    this.ConfigurationsService.set(GeneralSettingsConstants.POSTMASTER, {
                        [GeneralSettingsConstants.ACTIVE_MESSAGE_CONFIGURATION_CONTACT_FIELDS]: activeMessageContactFieldsSearch,
                    }, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled),
                    this.ConfigurationsService.set(GeneralSettingsConstants.POSTMASTER, {
                        [GeneralSettingsConstants.ACTIVE_MESSAGE_CONFIGURATION_SEARCH_SOURCE]: activeMessageSearchSource,
                    }, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled),
                ];
                if (this.isActiveMessageSettingsValidationEnabled) {
                    if (!this.activeMessageUseRouter && this.activeMessageConfiguration.routerIdentity) {
                        this.activeMessageRouterIdentity = undefined;
                        saveConfigurations.push(this.ConfigurationsService.deleteSingle(GeneralSettingsConstants.POSTMASTER, GeneralSettingsConstants.ACTIVE_MESSAGE_CONFIGURATION_ROUTER_IDENTITY, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled));
                    }
                    else if (await this.validateRouterIfInformedOrThrow()) {
                        this.activeMessageRouterIdentity = this.getRouterName(this.activeMessageRouterIdentity);
                        let routerIdentity = this.activeMessageRouterIdentity;
                        if (!this.activeMessageRouterIdentity.includes(this.routerIdDomain)) {
                            routerIdentity = this.activeMessageRouterIdentity + this.routerIdDomain;
                        }
                        saveConfigurations.push(this.ConfigurationsService.set(GeneralSettingsConstants.POSTMASTER, {
                            [GeneralSettingsConstants.ACTIVE_MESSAGE_CONFIGURATION_ROUTER_IDENTITY]: routerIdentity,
                        }, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled));
                    }
                }
                await Promise.all(saveConfigurations);
                this.SegmentService.createApplicationTrack({
                    trackEvent: ActiveMessageSegmentEventsConstants.ACTIVE_MESSAGE_SAVE,
                    application: this.application,
                    payload: {
                        activeMessageConfiguration: this.activeMessageConfiguration,
                    },
                });
                if (this.isActiveMessageSettingsValidationEnabled) {
                    await this.validateActiveMessagePending();
                    await this.loadPendingActiveMessageSettingsList();
                }
                this.canSaveActiveMessageConfiguration = false;
                this.showToast(await this.$translate('utils.successMsg.1'), ToastType.Success);
            }
            catch (error) {
                this.showToast(await this.$translate('utils.errorMsg.47'), ToastType.Danger);
            }
            finally {
                this.LoadingService.stopLoading();
                this.isActiveMessageConfigInService = false;
            }
        };
        this.validateActiveMessagePending = async () => {
            const result = await this.ActiveMessageDeskSharedService.getPendingSettingsValidation();
            if (result && result.status !== 'success') {
                throw new Error('error on validation');
            }
            this.pendingActiveMessageSettings = result.resource;
        };
        this.getRouterIdentityInput = () => {
            return document.getElementById('active-message-router-identity-input');
        };
        this.toggleUseRouter = async (event) => {
            this.activeMessageUseRouter = event.detail.checked;
            if (!this.activeMessageUseRouter) {
                const routerIdentityInput = this.getRouterIdentityInput();
                routerIdentityInput.danger = false;
                this.removeSourceFromSearch('router');
            }
            this.canSaveActiveMessageConfiguration = this.checkIfActiveMessageConfigurationCanBeSaved();
        };
        this.onChangeRouterIdentityValue = async (event) => {
            this.activeMessageRouterIdentity = event.detail.value;
            const isValueInvalid = !event.detail.value || event.detail.value === null || event.detail.value === '';
            if (isValueInvalid && this.activeMessageUseRouter) {
                event.srcElement.danger = true;
                event.srcElement.errorMessage = await this.getRouterConfigValidationKey(ActiveMessageSettingsConstants.INVALID_ROUTERID);
                this.canSaveActiveMessageConfiguration = false;
            }
            else {
                event.srcElement.danger = false;
            }
            this.canSaveActiveMessageConfiguration = this.checkIfActiveMessageConfigurationCanBeSaved();
        };
        this.getRouterConfigValidationKey = async (code) => {
            let translateSelector = '';
            switch (code) {
                case ActiveMessageSettingsConstants.ROUTER_NOT_FOUND:
                case ActiveMessageSettingsConstants.OWNER_DOES_NOT_BELONG_SAME_ORGANIZATION_THE_OWNER_IMPERSONATED: {
                    translateSelector = ActiveMessageSettingsConstants.DIFFERENT_TENANT;
                    return await this.$translate(ActiveMessageSettingsConstants.ROUTER_CONFIG + translateSelector, { chatbot_ID: this.application.shortName });
                }
                case ActiveMessageSettingsConstants.IDENTITY_DOES_NOT_HAS_WHATSAPP_CONNECTED: {
                    translateSelector = ActiveMessageSettingsConstants.NO_WHATSAPP_CHANNEL_CONNECTED;
                    break;
                }
                case ActiveMessageSettingsConstants.ROUTER_AND_CHATBOT_ARE_THE_SAME: {
                    translateSelector = ActiveMessageSettingsConstants.ROUTER_ID_MUST_BE_DIFFERENT_THAN_CHATBOT;
                    break;
                }
                case ActiveMessageSettingsConstants.ROUTER_DOES_NOT_BELONG_TO_AN_ORGANIZATION: {
                    translateSelector = ActiveMessageSettingsConstants.ROUTERBOT_HAVE_NO_TENANT;
                    break;
                }
                case ActiveMessageSettingsConstants.ID_IS_NOT_A_ROUTER: {
                    translateSelector = ActiveMessageSettingsConstants.ID_INFORMED_IS_NOT_A_ROUTER;
                    break;
                }
                case ActiveMessageSettingsConstants.ROUTER_VALIDATION_ERROR:
                default: {
                    translateSelector = ActiveMessageSettingsConstants.INVALID_ROUTERID;
                    break;
                }
            }
            return await this.$translate(ActiveMessageSettingsConstants.ROUTER_CONFIG + translateSelector);
        };
        this.setRuleForInactivity = async (event) => {
            this.restoreAfterCustomerMessage = event.detail?.checked;
            await this.validFormAutoClosingOfTicketsByCustomerInactivity();
        };
    }
    async $onInit() {
        this.hasWritingPermission = await this.PermissionsService.hasPermissions('write', 'desk');
        this.SegmentService.createApplicationTrack({
            trackEvent: GeneralSettingsTracks.GENERAL_SETTING_OPENED, application: this.application,
        });
    }
    async checkFeatures() {
        await super.checkFeatures();
        await this.getDeskConfiguration(undefined);
        this.initInputWatchers();
        this.isAgentResponseTimeAlertEnabled = await GeneralSettingsFeatures.isAgentResponseTimeAlertEnabled();
        this.isCustomerResponseTimeAlertEnabled = await GeneralSettingsFeatures.isCustomerResponseTimeAlertEnabled();
        this.isInsertAttachmentIntoDeskChatEnabled = await GeneralSettingsFeatures.isInsertAttachmentIntoDeskChatEnabled();
        this.isSendAudioRecordingEnabled = await GeneralSettingsFeatures.isSendAudioRecordingOnDeskEnabled();
        this.isActiveMessagesPermissionEnabled = await ActiveMessageFeatures.isActiveMessagesPermissionEnabled();
        this.isActiveMessageSettingsValidationEnabled = await ActiveMessageFeatures.isActiveMessageSettingsValidationEnabled();
        this.isMessageBeforeAutoClosingEnabled = await GeneralSettingsFeatures.isActiveMessageAutoClosedEnabled();
        this.isInsertExternalAttachmentIntoDeskChatEnabled = await GeneralSettingsFeatures.isInsertExternalAttachmentIntoDeskChatEnabled();
        this.isRedirectNoAgentsAvailable = await await BuilderFeatures.isRedirectNoAgentsAvailableEnabled();
        this.isConfigurationsApplicationsDomainUsageGetEnabled = await AttendanceFeatures.isUseConfigurationsDomainOnAttendanceOperationsGetEnabled();
        this.isConfigurationsApplicationsDomainUsageSetEnabled = await AttendanceFeatures.isUseConfigurationsDomainOnAttendanceOperationsSetEnabled();
        this.limitHour = GeneralSettingsConstants.LIMIT_HOUR;
        this.limitMinutes = GeneralSettingsConstants.LIMIT_MINUTE;
        this.unityOptions = await this.fillUnityOptions();
        this.autoClosingUnityOptions = await this.fillAutoClosingUnityOptions();
        const featureDataPromises = [];
        featureDataPromises.push(this.getTransferWithoutAgents());
        featureDataPromises.push(this.getSendEmojis());
        featureDataPromises.push(this.getTags());
        featureDataPromises.push(this.getAgentSlots());
        featureDataPromises.push(this.setIfDirectTransferIsEnabled());
        featureDataPromises.push(this.getAutoClosingOfTicketsByCustomerInactivity());
        if (this.isAgentResponseTimeAlertEnabled) {
            featureDataPromises.push(this.getAgentMaxResponseTimeAlert());
        }
        if (this.isCustomerResponseTimeAlertEnabled) {
            featureDataPromises.push(this.getCustomerResponseTimesAlert());
        }
        if (this.isInsertAttachmentIntoDeskChatEnabled) {
            featureDataPromises.push(this.getSendAttachment());
        }
        if (this.isInsertExternalAttachmentIntoDeskChatEnabled) {
            featureDataPromises.push(this.getBlockExternalAttachment());
        }
        if (this.isSendAudioRecordingEnabled) {
            featureDataPromises.push(this.getSendAudioRecording());
        }
        if (this.isActiveMessagesPermissionEnabled) {
            this.isWhatsAppChannelConnected = await this.ActiveMessageDeskSharedService.getIsWhatsAppConnected();
            if (this.isWhatsAppChannelConnected || this.isActiveMessageSettingsValidationEnabled) {
                featureDataPromises.push(this.getActiveMessagePermission());
            }
        }
        featureDataPromises.push(this.getEnableNumberCustomerWaiting());
        if (this.isRedirectNoAgentsAvailable) {
            featureDataPromises.push(this.getRedirectWhenNoAgentsQueue());
        }
        await Promise.all(featureDataPromises);
        this.hasWritingPermission = await this.PermissionsService.hasPermissions('write', 'desk');
        this.initWindowWatchers();
        this.canSaveAutoClosingOfTicketsByCustomerInactivity = false;
    }
    async getTags() {
        try {
            let resource = await this.BucketService.get(TAG_KEY);
            resource = JSON.parse(resource);
            this.tags =
                resource.tags.map(t => t.text) || [];
            this.hasTags = resource.hasTags || false;
            this.isTagsRequired = resource.isTagsRequired || false;
        }
        catch (err) {
            this.tags = [];
            console.error(err);
        }
        finally {
            this.showTags = this.hasTags;
        }
    }
    async getTransferWithoutAgents() {
        this.canTransferWithoutAgents = await this.getDeskConfiguration(AttendanceConstants.TRANSFER_WITHOUT_AGENTS_CONFIG, false);
        this.canTransferDirectly = await this.getDeskConfiguration(AttendanceConstants.TRANSFER_DIRECTLY_CONFIG, false);
    }
    async getAgentMaxResponseTimeAlert() {
        this.agentResponseTimeAlertEnabled = await this.getDeskConfiguration(GeneralSettingsConstants.AGENT_RESPONSE_DELAY_ENABLED);
        this.showAgentResponseTimeAlert = this.agentResponseTimeAlertEnabled;
        const agentMaxResponseDelay = await this.getDeskConfiguration(GeneralSettingsConstants.AGENT_MAX_RESPONSE_DELAY);
        if (this.agentResponseTimeAlertEnabled === undefined) {
            this.agentResponseTimeAlertEnabled = agentMaxResponseDelay && !isNaN(agentMaxResponseDelay) ? true : false;
            this.showAgentResponseTimeAlert = this.agentResponseTimeAlertEnabled;
        }
        this.agentResponseTimeUnity = this.getCustomerTimesUnity(agentMaxResponseDelay);
        this.agentResponseTimeAlert = Number(agentMaxResponseDelay) / this.agentResponseTimeUnity;
    }
    async getCustomerResponseTimesAlert() {
        this.customerResponseTimesAlertEnabled = await this.getDeskConfiguration(GeneralSettingsConstants.CUSTOMER_RESPONSE_DELAY_ENABLED);
        this.showCustomerResponseTimesAlert = this.customerResponseTimesAlertEnabled;
        const customerMaxResponseDelay = await this.getDeskConfiguration(GeneralSettingsConstants.CUSTOMER_MAX_RESPONSE_DELAY);
        const customerWarningResponseDelay = await this.getDeskConfiguration(GeneralSettingsConstants.CUSTOMER_WARNING_RESPONSE_DELAY);
        if (this.customerResponseTimesAlertEnabled === undefined) {
            this.customerResponseTimesAlertEnabled = (customerMaxResponseDelay && !isNaN(customerMaxResponseDelay)) || (customerWarningResponseDelay && !isNaN(customerWarningResponseDelay));
            this.showCustomerResponseTimesAlert = this.customerResponseTimesAlertEnabled;
        }
        this.customerMaxResponseTimeUnity = this.getCustomerTimesUnity(customerMaxResponseDelay);
        this.customerMaxResponseTimeAlert = Number(customerMaxResponseDelay) / this.customerMaxResponseTimeUnity;
        this.customerWarningResponseTimeUnity = this.getCustomerTimesUnity(customerWarningResponseDelay);
        this.customerWarningResponseTimeAlert = Number(customerWarningResponseDelay) / this.customerWarningResponseTimeUnity;
    }
    async fillUnityOptions() {
        const secs = await this.$translate('attendance-settings.timeUnities.secs');
        const mins = await this.$translate('attendance-settings.timeUnities.mins');
        const hours = await this.$translate('attendance-settings.timeUnities.hours');
        const days = await this.$translate('attendance-settings.timeUnities.days');
        return [
            {
                value: 1,
                label: secs,
            },
            {
                value: 60,
                label: mins,
            },
            {
                value: 3600,
                label: hours,
            },
            {
                value: 86400,
                label: days,
            },
        ];
    }
    async fillAutoClosingUnityOptions() {
        const mins = await this.$translate('attendance-settings.timeUnities.mins');
        const hours = await this.$translate('attendance-settings.timeUnities.hours');
        return [
            {
                value: 60,
                label: mins,
            },
            {
                value: 3600,
                label: hours,
            },
        ];
    }
    getCustomerTimesUnity(time) {
        if (time % GeneralSettingsConstants.DAY_IN_SECONDS === 0) {
            return GeneralSettingsConstants.DAY_IN_SECONDS;
        }
        else if (time % GeneralSettingsConstants.HOUR_IN_SECONDS === 0) {
            return GeneralSettingsConstants.HOUR_IN_SECONDS;
        }
        else if (time % GeneralSettingsConstants.MINUTE_IN_SECONDS === 0) {
            return GeneralSettingsConstants.MINUTE_IN_SECONDS;
        }
        else {
            return 1;
        }
    }
    async getAutoClosingOfTicketsByCustomerInactivity() {
        const autoClosingOfTicketsAllowed = await this.getDeskConfiguration(GeneralSettingsConstants.AUTOMATIC_CLOSED_TICKET_ALLOWED);
        const autoClosingOfTickets = await this.getDeskConfiguration(GeneralSettingsConstants.AUTOMATIC_CLOSED_TICKET_ENABLED);
        const customerInactivityTimeMinutesValue = await this.getDeskConfiguration(GeneralSettingsConstants.MAX_CLIENT_MINUTES_DOWNTIME);
        const customerInactivityOnlyWhenHasAttendantInteraction = await this.getDeskConfiguration(GeneralSettingsConstants.EXPECT_INTERACTION_AGENT);
        const customerInactivityClosingAddTags = await this.getDeskConfiguration(GeneralSettingsConstants.USE_INACTIVITY_TAGS);
        const customerInactivityClosingTags = await this.getDeskConfiguration(GeneralSettingsConstants.INACTIVITY_TAGS);
        const customerInactivityTimeUnity = this.getAutoClosingOfTicketsByInactivityTimeUnity(Number(customerInactivityTimeMinutesValue) * GeneralSettingsConstants.MINUTE_IN_SECONDS);
        const customerRemoveTicketClosedAttendance = await this.getDeskConfiguration(GeneralSettingsConstants.REMOVE_TICKET_CLOSED_ATTENDANCE);
        const customerUseMessageBeforeAutoClosing = await this.getDeskConfiguration(GeneralSettingsConstants.USE_MESSAGE_BEFORE_AUTO_CLOSED_TICKET);
        const customerMessageBeforeAutoClosing = await this.getDeskConfiguration(GeneralSettingsConstants.MESSAGE_BEFORE_AUTO_CLOSED_TICKET);
        const customerMessageBeforeAutoClosingTimeValue = await this.getDeskConfiguration(GeneralSettingsConstants.MESSAGE_BEFORE_AUTO_CLOSED_TICKET_DOWNTIME);
        const customerMessageBeforeAutoClosingTimeUnity = this.getAutoClosingOfTicketsByInactivityTimeUnity((Number(customerInactivityTimeMinutesValue) - Number(customerMessageBeforeAutoClosingTimeValue)) * GeneralSettingsConstants.MINUTE_IN_SECONDS);
        const clientInactivityTimerOnAgentInteraction = await this.getDeskConfiguration(GeneralSettingsConstants.RESET_CLIENT_INACTIVITY_TIMER_ON_AGENT_INTERACTION);
        const clientInactivityTimerOnFirstAgentInteraction = await this.getDeskConfiguration(GeneralSettingsConstants.RESET_CLIENT_INACTIVITY_TIMER_ON_FIRST_AGENT_INTERACTION);
        this.isAutoClosingOfTicketsByCustomerInactivityAllowed = autoClosingOfTicketsAllowed ?? false;
        this.isAutoClosingOfTicketsByCustomerInactivityEnabledInitial = autoClosingOfTickets ?? false;
        this.isAutoClosingOfTicketsByCustomerInactivityEnabled = autoClosingOfTickets ?? false;
        this.showAutoClosingOfTicketsByCustomerInactivity = this.isAutoClosingOfTicketsByCustomerInactivityEnabled;
        this.autoClosingOfTicketsByCustomerInactivityTimeUnity = customerInactivityTimeUnity;
        this.autoClosingOfTicketsByCustomerInactivityTimeValue = (Number(customerInactivityTimeMinutesValue) * GeneralSettingsConstants.MINUTE_IN_SECONDS) / customerInactivityTimeUnity;
        this.autoClosingOfTicketsByCustomerInactivityOnlyWhenHasAttendantInteraction = customerInactivityOnlyWhenHasAttendantInteraction;
        this.autoClosingOfTicketsByCustomerInactivityAddTagsWhenClosingTheTicket = customerInactivityClosingAddTags;
        this.isClientInactivityTimerOnAgentInteraction = clientInactivityTimerOnAgentInteraction;
        this.isClientInactivityTimerOnFirstAgentInteraction = clientInactivityTimerOnFirstAgentInteraction;
        if (customerInactivityClosingTags) {
            this.autoClosingOfTicketsByCustomerInactivityTags = JSON.parse(customerInactivityClosingTags);
        }
        this.removeTicketClosedAttendance = customerRemoveTicketClosedAttendance;
        this.useMessageBeforeAutoClosing = customerUseMessageBeforeAutoClosing;
        this.messageBeforeAutoClosing = customerMessageBeforeAutoClosing;
        this.messageBeforeAutoClosingTimeUnity = customerMessageBeforeAutoClosingTimeUnity;
        this.messageBeforeAutoClosingTimeValue = ((Number(customerInactivityTimeMinutesValue) - Number(customerMessageBeforeAutoClosingTimeValue)) * GeneralSettingsConstants.MINUTE_IN_SECONDS) / customerMessageBeforeAutoClosingTimeUnity;
        this.restoreAfterCustomerMessage = clientInactivityTimerOnAgentInteraction ?? false;
    }
    getAutoClosingOfTicketsByInactivityTimeUnity(time) {
        if (time % GeneralSettingsConstants.HOUR_IN_SECONDS === 0) {
            return GeneralSettingsConstants.HOUR_IN_SECONDS;
        }
        else {
            return GeneralSettingsConstants.MINUTE_IN_SECONDS;
        }
    }
    async getAgentSlots() {
        this.autoDistributionEnabled = await this.getDeskConfiguration(GeneralSettingsConstants.AGENT_SLOTS_ENABLED);
        const agentSlots = await this.getDeskConfiguration(GeneralSettingsConstants.AGENT_SLOTS);
        if (this.autoDistributionEnabled === undefined) {
            this.autoDistributionEnabled = agentSlots ? true : false;
        }
        if (agentSlots !== undefined) {
            this.agentSlots = Number(agentSlots);
        }
        this.showAutoDistribution = this.autoDistributionEnabled;
    }
    async getSendEmojis() {
        this.canSendEmojis = await this.getDeskConfiguration(GeneralSettingsConstants.CAN_SEND_EMOJI, true);
    }
    async getSendAttachment() {
        this.canSendAttachment = await this.getDeskConfiguration(GeneralSettingsConstants.CAN_SEND_ATTACHMENT, true);
        this.showOptionToBlockExternalFile = this.canSendAttachment;
    }
    async getBlockExternalAttachment() {
        this.blockExternalAttachment = await this.getDeskConfiguration(GeneralSettingsConstants.BLOCK_EXTERNAL_ATTACHMENT, false);
    }
    async getActiveMessagePermission() {
        this.isActiveMessageConfigInService = true;
        this.isActiveMessagesEnabled = await this.getDeskConfiguration(GeneralSettingsConstants.ACTIVE_MESSAGE_ENABLED, false);
        this.isActiveMessageSettingsInProgress = await this.getDeskConfiguration(GeneralSettingsConstants.ACTIVE_MESSAGE_SETTINGS_PROGRESS, false);
        if (this.isActiveMessagesEnabled || this.isActiveMessageSettingsInProgress) {
            await this.loadActiveMessageConfiguration();
        }
        this.isActiveMessageConfigInService = false;
    }
    async getEnableNumberCustomerWaiting() {
        this.waitingTicketsCountHiddenness = await this.getDeskConfiguration(GeneralSettingsConstants.WAITING_TICKETS_COUNT_HIDDENNESS, false);
    }
    async getRedirectWhenNoAgentsQueue() {
        this.redirectWhenNoAgentsQueue = await this.getDeskConfiguration(GeneralSettingsConstants.REDIRECT_WHEN_NO_AGENTS_ON_QUEUE, false);
    }
    async getSendAudioRecording() {
        this.canSendAudioRecording = await this.getDeskConfiguration(GeneralSettingsConstants.CAN_SEND_AUDIO_RECORDING, false);
    }
    async setIfDirectTransferIsEnabled() {
        this.isDirectTransferFeatureToggleEnabled = await AttendanceFeatures.isDirectTransferEnabled();
        const isOrleansEnabled = await this.DeskConfigurationService.getDeskConfiguration(AttendanceConstants.DISTRIBUTION_TYPE, undefined, this.isConfigurationsApplicationsDomainUsageGetEnabled) === AttendanceConstants.ORLEANS_DISTRIBUTION;
        const isRedisEnabled = await this.DeskConfigurationService.getDeskConfiguration(AttendanceConstants.DISTRIBUTION_TYPE, undefined, this.isConfigurationsApplicationsDomainUsageGetEnabled) === AttendanceConstants.REDIS_DISTRIBUTION;
        this.isDirectTransferEnabled = this.isDirectTransferFeatureToggleEnabled && (isOrleansEnabled || isRedisEnabled);
    }
    async getDeskConfiguration(key, defaultValue = undefined, reloadDeskConfiguration = false) {
        try {
            if (!this.deskConfiguration || reloadDeskConfiguration) {
                this.deskConfiguration = await this.ConfigurationsService.get(GeneralSettingsConstants.POSTMASTER, undefined, this.isConfigurationsApplicationsDomainUsageGetEnabled);
            }
            if (!key ||
                !this.deskConfiguration[key] ||
                this.deskConfiguration[key] === null ||
                (typeof this.deskConfiguration[key] === 'string' && this.deskConfiguration[key].toLowerCase() === 'null')) {
                return defaultValue;
            }
            if (typeof this.deskConfiguration[key] === 'boolean') {
                this.deskConfiguration[key] = this.deskConfiguration[key].toString();
            }
            if (typeof this.deskConfiguration[key] === 'string') {
                if (this.deskConfiguration[key].toLowerCase() === 'true') {
                    this.deskConfiguration[key] = true;
                }
                else if (this.deskConfiguration[key].toLowerCase() === 'false') {
                    this.deskConfiguration[key] = false;
                }
            }
            return this.deskConfiguration[key];
        }
        catch (err) {
            console.error(err);
        }
    }
    initWindowWatchers() {
        const unsavedChangesListener = (isWindowClosing, e) => {
            const message = this.$translate.instant('modules.application.detail.persistentMenu.confirmationMessage');
            if (this.canSaveTags ||
                this.canSaveAgentResponseTimeAlert ||
                this.canSaveCustomerResponseTimeAlert ||
                this.canSaveAutoClosingOfTicketsByCustomerInactivity ||
                this.canSaveAutoDistribution) {
                if (!isWindowClosing &&
                    !e.defaultPrevented &&
                    !confirm(message)) {
                    e.preventDefault();
                    return false;
                }
                e.returnValue = message;
                return message;
            }
        };
        this.$window.onbeforeunload = unsavedChangesListener.bind(this, true);
        const onStateChangeStartCleanup = this.$scope.$on('$stateChangeStart', unsavedChangesListener.bind(this, false));
        this.$scope.$on('$destroy', () => {
            onStateChangeStartCleanup();
            window.onbeforeunload = undefined;
        });
    }
    initInputWatchers() {
        const tagsLenghtWatchCleanup = this.$scope.$watch('$ctrl.tags.length', (newValue) => {
            if (newValue === 0) {
                this.isTagsRequired = false;
            }
        });
        const hasTagsWatchCleanup = this.$scope.$watch('$ctrl.hasTags', (newValue, oldValue) => {
            if (newValue !== undefined && oldValue !== undefined) {
                if (!newValue && this.tags.length === 0) {
                    this.isTagsRequired = false;
                }
                if (newValue) {
                    this.SegmentService.createBotTrack('helpdesk-general-settings-tags-enabled', this.application);
                }
                else {
                    this.SegmentService.createBotTrack('helpdesk-general-settings-tags-disabled', this.application);
                }
                this.saveTags();
                this.canSaveTags = false;
            }
        });
        this.$scope.$on('$destroy', () => {
            tagsLenghtWatchCleanup();
            hasTagsWatchCleanup();
        });
    }
    async validateCustomerResponseTimes() {
        if (!this.showCustomerResponseTimesAlert) {
            return;
        }
        const customerWarningResponseInput = document.getElementById('customer-warning-response-time-input');
        const customerMaxResponseInput = document.getElementById('customer-max-response-time-input');
        const customerWarningResponseUnity = await document.getElementById('customer-warning-response-time-unity').value;
        const customerMaxResponseUnity = await document.getElementById('customer-max-response-time-unity').value;
        const timeOfFirstAlert = parseFloat(customerWarningResponseInput.value) * customerWarningResponseUnity;
        const timeOfSecondAlert = parseFloat(customerMaxResponseInput.value) * customerMaxResponseUnity;
        if (timeOfFirstAlert >= timeOfSecondAlert) {
            customerMaxResponseInput.danger = true;
            customerMaxResponseInput.errorMessage = this.$translate.instant('attendance-settings.customerResponseTimeAlerts.inputError');
            this.canSaveCustomerResponseTimeAlert = false;
        }
        else {
            customerWarningResponseInput.danger = false;
            customerMaxResponseInput.danger = false;
            this.customerWarningResponseTimeAlert = parseFloat(customerWarningResponseInput.value);
            this.customerMaxResponseTimeAlert = parseFloat(customerMaxResponseInput.value);
            this.customerWarningResponseTimeUnity = customerWarningResponseUnity;
            this.customerMaxResponseTimeUnity = customerMaxResponseUnity;
            this.canSaveCustomerResponseTimeAlert = true;
        }
    }
    isNullOrUndefinedOrNaN(value) {
        return value === undefined || value === null || isNaN(value);
    }
    async saveAgentResponseTimeAlertsAndTrack() {
        await this.saveDeskConfiguration(GeneralSettingsConstants.AGENT_MAX_RESPONSE_DELAY, this.showAgentResponseTimeAlert && this.agentResponseTimeAlert ? this.agentResponseTimeAlert * this.agentResponseTimeUnity : 'null');
        const trackEvent = this.startAgentResponseTimeAlert ? 'helpdesk-general-settings-agent-response-delay-enabled' : 'helpdesk-general-settings-agent-max-response-time-changed';
        this.SegmentService.createApplicationTrack({ trackEvent, application: this.application, payload: {} });
        this.startAgentResponseTimeAlert = false;
        this.canSaveAgentResponseTimeAlert = false;
    }
    isInvalidAgentResponseTimeAlerts() {
        const agentAlertInput = document.getElementById('agent-max-response-time-input').value;
        const invalidTimeAlert = this.agentResponseTimeAlert < 1 || !this.agentResponseTimeAlert || !agentAlertInput;
        const invalidTimeUnity = !this.agentResponseTimeUnity;
        return invalidTimeAlert || invalidTimeUnity;
    }
    async saveCustomerResponseTimeAlertsAndTrack() {
        try {
            const customerMaxResponseDelay = this.customerMaxResponseTimeAlert * this.customerMaxResponseTimeUnity;
            const customerWarningResponseDelay = this.customerWarningResponseTimeAlert * this.customerWarningResponseTimeUnity;
            this.LoadingService.startLoading();
            const saveConfigurations = [
                this.ConfigurationsService.set(GeneralSettingsConstants.POSTMASTER, {
                    CustomerMaxResponseDelay: customerMaxResponseDelay,
                }, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled),
                this.ConfigurationsService.set(GeneralSettingsConstants.POSTMASTER, {
                    CustomerWarningResponseDelay: customerWarningResponseDelay,
                }, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled),
            ];
            await Promise.all(saveConfigurations);
            const trackEvent = this.startCustomerResponseTimeAlert ? 'helpdesk-general-settings-customer-response-delay-enabled' : 'helpdesk-general-settings-customer-response-times-changed';
            this.startCustomerResponseTimeAlert = false;
            this.SegmentService.createApplicationTrack({ trackEvent, application: this.application, payload: {} });
            this.deskConfiguration.CustomerMaxResponseDelay = customerMaxResponseDelay;
            this.deskConfiguration.CustomerWarningResponseDelay = customerWarningResponseDelay;
            const successMsg = await this.$translate('utils.successMsg.1');
            this.showToast(successMsg, ToastType.Success);
            this.canSaveCustomerResponseTimeAlert = false;
        }
        catch (error) {
            const errorMsg4 = await this.$translate('utils.errorMsg.4');
            this.showToast(errorMsg4, ToastType.Danger);
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    isInvalidCustomerResponseTimeAlerts() {
        const haveNullOrUndefinedInputs = this.isNullOrUndefinedOrNaN(this.customerWarningResponseTimeUnity) ||
            this.isNullOrUndefinedOrNaN(this.customerMaxResponseTimeUnity);
        return haveNullOrUndefinedInputs;
    }
    showMessageError(value) {
        return !value && value !== 0;
    }
    isLessThanOne(value) {
        return (Boolean(value) && value < 1) || value === 0;
    }
    validMaxInputTime(time, unit) {
        if (unit === GeneralSettingsConstants.HOUR_IN_SECONDS) {
            return (time > GeneralSettingsConstants.LIMIT_HOUR);
        }
        else if (unit === GeneralSettingsConstants.MINUTE_IN_SECONDS) {
            return (time > GeneralSettingsConstants.LIMIT_MINUTE);
        }
        else {
            return true;
        }
    }
    async isNotEmptyCustomerAlertInputs() {
        const customerWarningResponseInput = document.getElementById('customer-warning-response-time-input');
        const customerMaxResponseInput = document.getElementById('customer-max-response-time-input');
        let valid = true;
        if (!this.isValidUnity(parseFloat(customerWarningResponseInput.value))) {
            customerWarningResponseInput.danger = true;
            customerWarningResponseInput.errorMessage = this.$translate.instant('attendance-settings.customerResponseTimeAlerts.tip');
            valid = false;
            this.canSaveCustomerResponseTimeAlert = false;
        }
        else {
            customerWarningResponseInput.danger = false;
        }
        if (!this.isValidUnity(parseFloat(customerMaxResponseInput.value))) {
            customerMaxResponseInput.danger = true;
            customerMaxResponseInput.errorMessage = this.$translate.instant('attendance-settings.customerResponseTimeAlerts.tip');
            valid = false;
            this.canSaveCustomerResponseTimeAlert = false;
        }
        else {
            customerMaxResponseInput.danger = false;
        }
        return valid;
    }
    isValidUnity(value) {
        if (value && value >= 0) {
            return true;
        }
        else {
            return false;
        }
    }
    async saveSlots() {
        await this.saveDeskConfiguration(GeneralSettingsConstants.AGENT_SLOTS, this.agentSlots);
        this.SegmentService.createBotTrack('helpdesk-general-settings-distribution-changed', this.application);
        this.canSaveAutoDistribution = false;
    }
    async saveTagsAndTrack() {
        this.SegmentService.createBotTrack('helpdesk-general-settings-tags-added', this.application);
        await this.saveTags();
    }
    async saveTags() {
        await this.executeWithLoadingAndResultHandler(true, async () => {
            const tags = this.tags.map(t => ({ text: t }));
            const settings = {
                tags: tags,
                hasTags: this.showTags,
                isTagsRequired: this.isTagsRequired,
            };
            await this.BucketService.set(TAG_KEY, JSON.stringify(settings), 'text/plain');
            this.canSaveTags = false;
        });
    }
    setDangerAttribute(elementId, dangerValue) {
        const targetElement = document.getElementById(elementId);
        targetElement?.setAttribute('danger', dangerValue.toString());
    }
    async saveAutoClosingOfTicketsByInactivity() {
        if (this.isInvaliddAutoClosingOfTicketsByCustomerInactivityTimeValue() && this.isAutoClosingOfTicketsByCustomerInactivityEnabled) {
            return;
        }
        try {
            this.LoadingService.startLoading();
            const customerAutoClossingInactivityTime = this.autoClosingOfTicketsByCustomerInactivityTimeValue * this.autoClosingOfTicketsByCustomerInactivityTimeUnity;
            const customerMessageBeforeAutoClosedValue = this.messageBeforeAutoClosingTimeValue * this.messageBeforeAutoClosingTimeUnity;
            const customerInactivityTime = this.autoClosingOfTicketsByCustomerInactivityTimeValue
                ? ((this.autoClosingOfTicketsByCustomerInactivityTimeValue * this.autoClosingOfTicketsByCustomerInactivityTimeUnity) / 60)
                : 'null';
            const customerMessageBeforeAutoClosedTime = this.messageBeforeAutoClosingTimeValue
                ? ((customerAutoClossingInactivityTime - customerMessageBeforeAutoClosedValue) / 60)
                : 'null';
            const customerInactivityOnlyWhenHasAttendantInteraction = this.autoClosingOfTicketsByCustomerInactivityOnlyWhenHasAttendantInteraction;
            const customerInactivityClosingAddTags = this.autoClosingOfTicketsByCustomerInactivityAddTagsWhenClosingTheTicket;
            const customerInactivityClosingTags = this.autoClosingOfTicketsByCustomerInactivityTags ? this.autoClosingOfTicketsByCustomerInactivityTags : 'null';
            const saveConfigurations = [
                this.ConfigurationsService.set(GeneralSettingsConstants.POSTMASTER, {
                    [GeneralSettingsConstants.AUTOMATIC_CLOSED_TICKET_ENABLED]: this.isAutoClosingOfTicketsByCustomerInactivityAllowed && this.isAutoClosingOfTicketsByCustomerInactivityEnabled,
                }, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled),
                this.ConfigurationsService.set(GeneralSettingsConstants.POSTMASTER, {
                    [GeneralSettingsConstants.MAX_CLIENT_MINUTES_DOWNTIME]: customerInactivityTime,
                }, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled),
                this.ConfigurationsService.set(GeneralSettingsConstants.POSTMASTER, {
                    [GeneralSettingsConstants.EXPECT_INTERACTION_AGENT]: customerInactivityOnlyWhenHasAttendantInteraction,
                }, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled),
                this.ConfigurationsService.set(GeneralSettingsConstants.POSTMASTER, {
                    [GeneralSettingsConstants.USE_INACTIVITY_TAGS]: customerInactivityClosingAddTags,
                }, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled),
                this.ConfigurationsService.set(GeneralSettingsConstants.POSTMASTER, {
                    [GeneralSettingsConstants.INACTIVITY_TAGS]: customerInactivityClosingTags,
                }, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled),
                this.ConfigurationsService.set(GeneralSettingsConstants.POSTMASTER, {
                    [GeneralSettingsConstants.REMOVE_TICKET_CLOSED_ATTENDANCE]: this.removeTicketClosedAttendance,
                }, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled),
                this.ConfigurationsService.set(GeneralSettingsConstants.POSTMASTER, {
                    [GeneralSettingsConstants.USE_MESSAGE_BEFORE_AUTO_CLOSED_TICKET]: this.useMessageBeforeAutoClosing,
                }, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled),
                this.ConfigurationsService.set(GeneralSettingsConstants.POSTMASTER, {
                    [GeneralSettingsConstants.MESSAGE_BEFORE_AUTO_CLOSED_TICKET]: this.messageBeforeAutoClosing,
                }, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled),
                this.ConfigurationsService.set(GeneralSettingsConstants.POSTMASTER, {
                    [GeneralSettingsConstants.MESSAGE_BEFORE_AUTO_CLOSED_TICKET_DOWNTIME]: customerMessageBeforeAutoClosedTime,
                }, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled),
            ];
            saveConfigurations.push(this.ConfigurationsService.set(GeneralSettingsConstants.POSTMASTER, {
                [GeneralSettingsConstants.RESET_CLIENT_INACTIVITY_TIMER_ON_AGENT_INTERACTION]: this.restoreAfterCustomerMessage,
            }, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled), this.ConfigurationsService.set(GeneralSettingsConstants.POSTMASTER, {
                [GeneralSettingsConstants.RESET_CLIENT_INACTIVITY_TIMER_ON_FIRST_AGENT_INTERACTION]: this.restoreAfterCustomerMessage,
            }, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled));
            await Promise.all(saveConfigurations);
            this.deskConfiguration.AutoClosingOfTickets = this.isAutoClosingOfTicketsByCustomerInactivityEnabled;
            this.deskConfiguration.AutoClosingOfTicketsByCustomerInactivityTime = customerInactivityTime;
            this.deskConfiguration.AutoClosingOfTicketsByCustomerInactivityOnlyWhenHasAttendantInteraction = customerInactivityOnlyWhenHasAttendantInteraction;
            this.deskConfiguration.AutoClosingOfTicketsByCustomerInactivityTags = customerInactivityClosingTags;
            const payLoadOnSave = {
                autoRemoveIsEnabled: this.removeTicketClosedAttendance,
                messageIsEnabled: this.messageBeforeAutoClosing,
                tagsIsEnabled: this.autoClosingOfTicketsByCustomerInactivityAddTagsWhenClosingTheTicket,
                FirstMessageIsEnabled: this.autoClosingOfTicketsByCustomerInactivityOnlyWhenHasAttendantInteraction,
                chosenRule: this.restoreAfterCustomerMessage ? GeneralSettingsTracks.GENERAL_SETTINGS_TICKET_CLOSURE_CHANGE_ATTENDANT_START :
                    GeneralSettingsTracks.GENERAL_SETTINGS_TICKET_CLOSURE_CHANGE_CUSTOMER_START,
            };
            this.SegmentService.createApplicationTrack({ trackEvent: GeneralSettingsTracks.GENERAL_SETTINGS_TICKET_CLOSURE_CHANGES_SAVED, application: this.application, payload: payLoadOnSave });
            if (this.isAutoClosingOfTicketsByCustomerInactivityEnabled != this.isAutoClosingOfTicketsByCustomerInactivityEnabledInitial) {
                this.isAutoClosingOfTicketsByCustomerInactivityEnabledInitial = this.isAutoClosingOfTicketsByCustomerInactivityEnabled;
            }
            if (this.isClientInactivityTimerOnAgentInteraction != this.restoreAfterCustomerMessage) {
                this.setTrackingStartingUseInactivityRule();
                this.isClientInactivityTimerOnAgentInteraction = this.restoreAfterCustomerMessage;
                this.isClientInactivityTimerOnFirstAgentInteraction = this.restoreAfterCustomerMessage;
            }
            const successMsg = await this.$translate('attendance-settings.save');
            this.canSaveAutoClosingOfTicketsByCustomerInactivity = false;
            this.showToast(successMsg, ToastType.Success);
        }
        catch (error) {
            const errorMsg4 = await this.$translate('utils.errorMsg.4');
            this.showToast(errorMsg4, ToastType.Danger);
        }
        finally {
            this.LoadingService.stopLoading();
            this.$scope.forms.autoClosingOfTicketsByCustomerInactivityForm.$setPristine();
        }
    }
    isInvaliddAutoClosingOfTickets() {
        return this.isInvaliddAutoClosingOfTicketsByCustomerInactivityTimeValue() || this.isInvalidAutoClosingOfTicketsByCustomerInactivityTags();
    }
    isInvaliddAutoClosingOfTicketsByCustomerInactivityTimeValue() {
        const invalidTimeValue = !this.autoClosingOfTicketsByCustomerInactivityTimeValue || this.autoClosingOfTicketsByCustomerInactivityTimeValue < 1 || !this.isAutoClosingOfTicketsByCustomerInactivityEnabled;
        const invalidTimeUnity = !this.autoClosingOfTicketsByCustomerInactivityTimeUnity;
        return invalidTimeValue || invalidTimeUnity;
    }
    isInvalidAutoClosingOfTicketsByCustomerInactivityTags() {
        const isClosingTagsRequired = this.autoClosingOfTicketsByCustomerInactivityAddTagsWhenClosingTheTicket;
        if (!isClosingTagsRequired) {
            return false;
        }
        return (!this.autoClosingOfTicketsByCustomerInactivityTags || this.autoClosingOfTicketsByCustomerInactivityTags.length === 0);
    }
    async saveDeskConfiguration(key, value, showToast = true) {
        await this.executeWithLoadingAndResultHandler(showToast, async () => {
            if (key && value !== null) {
                await this.ConfigurationsService.set(GeneralSettingsConstants.POSTMASTER, {
                    [key]: value,
                }, undefined, this.isConfigurationsApplicationsDomainUsageSetEnabled);
                this.deskConfiguration[key] = value;
            }
        });
    }
    async executeWithLoadingAndResultHandler(showToast = true, action) {
        try {
            this.LoadingService.startLoading();
            await action();
            if (showToast) {
                const successMsg = await this.$translate('utils.successMsg.1');
                this.showToast(successMsg, ToastType.Success);
            }
        }
        catch (e) {
            if (showToast) {
                const errorMsg4 = await this.$translate('utils.errorMsg.4');
                this.showToast(errorMsg4, ToastType.Danger);
            }
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async showToast(message, type) {
        const toastOptions = { msg: message, buttonText: await this.$translate('attendance-settings.ok') };
        await this.BlipToastService.show(type, toastOptions);
    }
    hideActiveMessageContactSearchSlownessWarning() {
        this.showActiveMessageContactSearchWarning = false;
    }
    async buildActiveMessageConfigurationObject() {
        const contactFields = await this.getDeskConfiguration(GeneralSettingsConstants.ACTIVE_MESSAGE_CONFIGURATION_CONTACT_FIELDS);
        const searchSource = await this.getDeskConfiguration(GeneralSettingsConstants.ACTIVE_MESSAGE_CONFIGURATION_SEARCH_SOURCE);
        const routerIdentity = await this.getDeskConfiguration(GeneralSettingsConstants.ACTIVE_MESSAGE_CONFIGURATION_ROUTER_IDENTITY);
        this.activeMessageUseRouter = routerIdentity !== undefined && routerIdentity !== '';
        this.activeMessageRouterIdentity = this.getRouterName(routerIdentity);
        return {
            contactFieldsSearch: contactFields?.split(',') ?? ['name', 'phoneNumber'],
            searchSource: searchSource?.split(',') ?? ['router'],
            routerIdentity: routerIdentity,
        };
    }
    getRouterName(routerFullId) {
        if (!routerFullId) {
            return undefined;
        }
        return routerFullId.replace(this.routerIdDomain, '');
    }
    addContactFieldToSearch(contactFieldName) {
        if (this.isContactFieldSelected(contactFieldName)) {
            return;
        }
        this.activeMessageConfiguration.contactFieldsSearch.push(contactFieldName);
    }
    removeContactFieldFromSearch(contactFieldName) {
        if (!this.isContactFieldSelected(contactFieldName)) {
            return;
        }
        this.activeMessageConfiguration.contactFieldsSearch = this.activeMessageConfiguration.contactFieldsSearch.filter((name) => name !== contactFieldName);
    }
    addSearchToSearch(sourceName) {
        if (this.isSearchSourceSelected(sourceName)) {
            return;
        }
        this.activeMessageConfiguration.searchSource.push(sourceName);
    }
    removeSourceFromSearch(sourceName) {
        if (!this.isSearchSourceSelected(sourceName)) {
            return;
        }
        this.activeMessageConfiguration.searchSource = this.activeMessageConfiguration.searchSource.filter((name) => name !== sourceName);
    }
    async loadActiveMessageConfiguration() {
        this.activeMessageConfiguration = await this.buildActiveMessageConfigurationObject();
        if (!this.isActiveMessageSettingsValidationEnabled) {
            return;
        }
        if (!this.pendingActiveMessageSettings) {
            await this.validateActiveMessagePending();
        }
        await this.loadPendingActiveMessageSettingsList();
    }
    async loadValidationsForRouterId(routerIdentityValidation) {
        if (this.activeMessageUseRouter) {
            const routerIdentityInput = this.getRouterIdentityInput();
            if (!routerIdentityInput) {
                return;
            }
            if (routerIdentityValidation.code !== 0) {
                routerIdentityInput.danger = true;
                this.canSaveActiveMessageConfiguration = false;
                routerIdentityInput.errorMessage = await this.getRouterConfigValidationKey(routerIdentityValidation.code);
            }
            else {
                routerIdentityInput.danger = false;
            }
        }
    }
    async loadPendingActiveMessageSettingsList() {
        if (!this.isActiveMessageSettingsValidationEnabled) {
            return;
        }
        await this.loadValidationsForRouterId(this.pendingActiveMessageSettings.routerIdentityValidation);
        this.pendingActiveMessageSettingsToShow =
            [
                this.buildPendingSettingsList(this.pendingActiveMessageSettings.essentialSettings, ActiveMessageSettingsConstants.ESSENTIAL_REQ),
                this.buildPendingSettingsList(this.pendingActiveMessageSettings.recommendedSettings, ActiveMessageSettingsConstants.RECOMMENDED_REQ),
            ];
        this.isActiveMessageSettingsInProgress = this.pendingActiveMessageSettings.activeMessageSettingInProgress;
        this.isActiveMessagesEnabled = this.pendingActiveMessageSettings.activeMessageEnabled;
        this.buildLegend();
    }
    buildPendingSettingsList(settingList, rootTxt) {
        const settingsList = settingList.map(element => this.buildRequirement(element));
        return { title: rootTxt + ActiveMessageSettingsConstants.TXT_TITLE, reqs: settingsList };
    }
    buildRequirement(configValidation) {
        const iconCss = this.getIconNameAndCss(configValidation.SettingStatus);
        const configName = this.getConfigName(configValidation.SettingCode);
        return {
            configName: configName,
            configLink: configName + ActiveMessageSettingsConstants.TXT_LINK,
            iconName: iconCss.iconName,
            css: iconCss.cssClass,
        };
    }
    checkIfActiveMessageConfigurationCanBeSaved() {
        this.isContactFieldsValid = this.activeMessageConfiguration.contactFieldsSearch.length > 0;
        this.isSearchSourceValid = this.activeMessageConfiguration.searchSource.length > 0;
        this.isRouterIdentityValid = !this.activeMessageUseRouter ||
            (this.activeMessageUseRouter &&
                this.activeMessageRouterIdentity &&
                this.activeMessageRouterIdentity.length > 0);
        return this.isContactFieldsValid &&
            this.isSearchSourceValid &&
            this.isRouterIdentityValid;
    }
    async validateRouterIfInformedOrThrow() {
        if (this.activeMessageUseRouter) {
            if (!new RegExp(ActiveMessageSettingsConstants.REGEX_IS_VALID_IDENTITY).test(this.activeMessageRouterIdentity)) {
                await this.loadValidationsForRouterId({ code: ActiveMessageSettingsConstants.INVALID_ROUTERID });
                throw new Error('routerId is not valid');
            }
            const routerValidation = await this.ActiveMessageDeskSharedService.getRouterIdValidation(this.activeMessageRouterIdentity);
            if (routerValidation.resource && routerValidation.resource.code !== 0) {
                await this.loadValidationsForRouterId(routerValidation.resource);
                throw new Error('routerId informed has problems');
            }
            return true;
        }
        return false;
    }
    toggleModal() {
        this.openPendingSettingsModal = !this.openPendingSettingsModal;
    }
    getConfigName(config) {
        switch (config) {
            case ActiveMessageSettingsConstants.WHATSAPP_CHANNEL_CONNECTED:
                return ActiveMessageSettingsConstants.ESSENTIAL_REQ + ActiveMessageSettingsConstants.TXT_WHATSAPP_CHANNEL_CONNECTED;
            case ActiveMessageSettingsConstants.HUMAN_FLOW_STATE:
                return ActiveMessageSettingsConstants.ESSENTIAL_REQ + ActiveMessageSettingsConstants.TXT_HUMAN_FLOW_STATE;
            case ActiveMessageSettingsConstants.MESSAGE_TEMPLATE_AT_WHATSAPP:
                return ActiveMessageSettingsConstants.RECOMMENDED_REQ + ActiveMessageSettingsConstants.TXT_MESSAGE_TEMPLATE_AT_WHATSAPP;
            case ActiveMessageSettingsConstants.MESSAGE_TEMPLATE_ENABLED_AT_BLIP:
                return ActiveMessageSettingsConstants.RECOMMENDED_REQ + ActiveMessageSettingsConstants.TXT_MESSAGE_TEMPLATE_ENABLED_AT_BLIP;
        }
        return '';
    }
    getIconNameAndCss(status) {
        switch (status) {
            case ActiveMessageSettingsConstants.CONFIGURED:
                return {
                    iconName: 'checkball',
                    cssClass: 'clr-p-green',
                };
            case ActiveMessageSettingsConstants.NOT_CONFIGURED:
                return {
                    iconName: 'warning',
                    cssClass: 'clr-cheetos',
                };
        }
        return {
            iconName: 'error',
            cssClass: 'clr-red',
        };
    }
    buildLegend() {
        this.modalLegend = [
            {
                iconName: 'warning',
                cssClass: 'clr-cheetos',
                description: ActiveMessageSettingsConstants.LEGEND_REQ + ActiveMessageSettingsConstants.TXT_LEGEND_NOT_CONFIGURED,
            },
            {
                iconName: 'error',
                cssClass: 'clr-red',
                description: ActiveMessageSettingsConstants.LEGEND_REQ + ActiveMessageSettingsConstants.TXT_LEGEND_ERROR,
            },
            {
                iconName: 'checkball',
                cssClass: 'clr-p-green',
                description: ActiveMessageSettingsConstants.LEGEND_REQ + ActiveMessageSettingsConstants.TXT_LEGEND_CONFIGURED,
            },
        ];
    }
    setTrackingStartingUseInactivityRule() {
        this.SegmentService
            .createApplicationTrack({
            trackEvent: this.restoreAfterCustomerMessage ? GeneralSettingsTracks.GENERAL_SETTINGS_TICKET_CLOSURE_CHANGE_ATTENDANT_START :
                GeneralSettingsTracks.GENERAL_SETTINGS_TICKET_CLOSURE_CHANGE_CUSTOMER_START,
            application: this.application,
        });
    }
}
GeneralSettingsController.$inject = ['application', 'DeskConfigurationService', 'LoadingService', 'BucketService', '$scope', '$translate', '$window', 'ConfigurationsService', 'PermissionsService', 'SegmentService', 'BlipToastService', 'ActiveMessageDeskSharedService', '$state'];
